import { Injectable, Injector } from "@angular/core";
import { BaseApi } from "@services/api/base.api";
import { Observable } from "rxjs";

@Injectable()
export class ContactApi extends BaseApi {
	constructor( injector: Injector ) { super(injector); }

	public postContact(
		name: string,
		email: string,
		subject: string,
		message: string,
	): Observable<any> {
		return this.post(
			this.url("/contact"),
			{ name, email, subject, message }
		).pipe(this.defaultMap);
	}

}
